import { useAppHookContext } from "@nkr/utils/rest-api";
import React, { useState } from "react";
import { Nav, NavItem } from "react-bootstrap";
import { DashCannedResponses } from "./pages/dash-canned-responses";
import DashIntakeConfig from "./pages/dash-intake-config";
import DashCenterWorkflowStatus from "../workflow-config";

interface IOwnProps {
    centerId    : number,
    isAdmin     : boolean,
    isAdminUser : boolean
}

const ReferralConfig = (props: IOwnProps) => {
    const { location }  = useAppHookContext();
    const segments      = location.pathname.split("/").filter(Boolean);
    const page          = segments.pop() || "";
    const basePrefix    = segments.join("/");

    return <>
        <div style={{ padding: '10px 0', backgroundColor: 'white', marginBottom: 10 }}>
            <Nav bsStyle='pills' className='center-pills' activeKey={page}>
                <NavItem eventKey='referral-config' href={`${basePrefix}/referral-config`}>
                    Referral Config
                </NavItem>

                <li role='presentation'><span>&nbsp;</span></li>

                <NavItem eventKey='workflow-config' href={`${basePrefix}/workflow-config`}>
                    DASH Workflow
                </NavItem>

                <li role='presentation'><span>&nbsp;</span></li>

                <NavItem eventKey='canned-responses' href={`${basePrefix}/canned-responses`}>
                    Canned Responses
                </NavItem>
            </Nav>
        </div>

        {page == "canned-responses" && <DashCannedResponses />}
        {page == "workflow-config" && <DashCenterWorkflowStatus centerId={props.centerId} isCenter={true} />}
        {page == "referral-config" && <DashIntakeConfig centerId={props.centerId} isAdmin={props.isAdmin} isAdminUser={props.isAdminUser} />}
    </>
}

export default ReferralConfig;